// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form[data-v-a68e40d4]{min-width:200px;border:1px solid #ccc;border-radius:10px;overflow:hidden}.form .title[data-v-a68e40d4]{color:#424d57;background-color:#f3f7f9;padding:12px 22px;text-align:center}.form .content[data-v-a68e40d4]{padding:12px 20px}.form .content .item[data-v-a68e40d4]{margin:10px 0}.form .content .item .label[data-v-a68e40d4]{color:rgba(66,77,87,.6);margin-bottom:5px}.form .content .item .value .email[data-v-a68e40d4]{color:#00f}", ""]);
// Exports
module.exports = exports;
